import { render, staticRenderFns } from "./ManufacturingLogbookPage.vue?vue&type=template&id=435856c8"
import script from "./ManufacturingLogbookPage.vue?vue&type=script&lang=js"
export * from "./ManufacturingLogbookPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports